import FilterUtils from '@/shared/utils/filters';

export default class RangeParameterScriptRequest {
  quantidade: any;

  valor: number;

  constructor(obj: any = {}) {
    this.quantidade = obj.quantidade === 'Infinito' ? null : Number(obj.quantidade);
    this.valor = parseFloat(FilterUtils.formatValue(obj.valor));
  }

  public static of(obj: any = {}): RangeParameterScriptRequest {
    return new RangeParameterScriptRequest(obj || {});
  }
}
